import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as React from 'react';
import { cn } from '~/util';

export const ScrollArea = React.forwardRef<
    React.ElementRef<typeof ScrollAreaPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & {
        viewportClassName?: string;
        scrollHideDelay?: number;
        orientation?: 'vertical' | 'horizontal';
        viewportRef?: React.Ref<HTMLDivElement>;
        viewportAsChild?: boolean;
    }
>(
    (
        {
            className,
            children,
            viewportClassName,
            viewportRef,
            orientation = 'vertical',
            scrollHideDelay = 100,
            viewportAsChild = false,
            ...props
        },
        ref,
    ) => (
        <ScrollAreaPrimitive.Root
            ref={ref}
            scrollHideDelay={scrollHideDelay}
            className={cn(
                'relative flex min-h-0 flex-col overflow-hidden',
                className,
            )}
            {...props}
        >
            {viewportAsChild ? (
                <ScrollAreaPrimitive.Viewport
                    asChild
                    className={cn(
                        'min-h-0 flex-1 rounded-[inherit] [&>div]:block! px-3 w-full',
                        viewportClassName,
                    )}
                    ref={viewportRef}
                >
                    {children as React.ReactElement}
                </ScrollAreaPrimitive.Viewport>
            ) : (
                <ScrollAreaPrimitive.Viewport
                    className={cn(
                        'min-h-0 flex-1 rounded-[inherit] [&>div]:block! px-3 w-full',
                        viewportClassName,
                    )}
                    ref={viewportRef}
                >
                    {children}
                </ScrollAreaPrimitive.Viewport>
            )}

            <ScrollAreaPrimitive.Scrollbar
                className={cn(
                    'bg-background-lighttransparent transition-colors',
                    orientation === 'vertical' && 'h-full w-2.5',
                    orientation === 'horizontal' && 'h-2.5 w-full',
                )}
                orientation={orientation}
            >
                <ScrollAreaPrimitive.ScrollAreaThumb
                    className={cn(
                        'bg-primary rounded-full transition-colors w-2.5',
                        orientation === 'vertical' && 'h-full w-2.5',
                        orientation === 'horizontal' && 'h-2.5 w-full',
                    )}
                />
            </ScrollAreaPrimitive.Scrollbar>

            <ScrollAreaPrimitive.Corner />
        </ScrollAreaPrimitive.Root>
    ),
);

ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
